const msg = {
  "login.name.error":"Wszystkie pola są obowiązkowe.",
  "login.password.error":"Wszystkie pola są obowiązkowe.",
  "login.store.error":"Wszystkie pola są obowiązkowe.",
  "login.form.error":"Błędne dane logowania.",
  "server.error":"Błąd serwera."
};
export default msg



// WEBPACK FOOTER //
// ./src/service/messages.js